import { mapGetters } from 'vuex'
export default {
    props: {
        value: {
            type: Object
        }
    },
    computed: {
        ...mapGetters({
            getUserById: 'staff/getById'
        }),
        selected: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        },
        listeners() {
            // as the table sv-model selected, they will raise the input,
            // allowing the external handlers to run too results in a double handle
            return {
                ...this.$listeners,
                input: null
            }
        }
    },
    methods: {
        applyCurrencyFormat(value, rounding) {
            if (!value) {
                value = 0
            }
            return '$' + value.formatCurrency(rounding)
        },
        applyPercentageFormat(value) {
            if (!value) {
                value = 0
            }
            return `(${(100 * value).round(2)}%)`
        },
        formatUTCDateToDate(value) {
            if (!value) {
                return
            }
            return new Date(value).toLocaleDateString('en-AU')
        },
        formatUTCDateToTime(date) {
            if (!date) {
                return
            }
            // DC NOTE: toLocaleTimeString() is OS dependant, Mac seems to have a problem...
            // :(
            // var dateWithoutSecond = new Date(value)
            // dateWithoutSecond.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            // return dateWithoutSecond
            var hours = date.getHours()
            var minutes = date.getMinutes()
            var ampm = hours >= 12 ? 'PM' : 'AM'
            hours = hours % 12
            hours = hours ? hours : 12 // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes
            var strTime = hours + ':' + minutes + ' ' + ampm
            return strTime
        },
        formatUTCFullDate(value) {
            if (!value) {
                return
            }
            // DC NOTE: toLocaleTimeString() is OS dependant, Mac seems to have a problem...
            // :(
            // return new Date(value).toISOString().replace(/T/, ' ').replace(/\..+/, '')
            var dateWithouthSecond = new Date(value)
            dateWithouthSecond.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            return dateWithouthSecond
        },
        formatContact(value) {
            if (value) {
                return `${value.first} ${value.last}`
            }
        },
        formatDate(row) {
            return new Date(row)
        }
    }
}
